import groupBy from 'lodash/groupBy'
import keyBy from 'lodash/keyBy'
import mapValues from 'lodash/mapValues'

export default function(response) {
    const baseEntities = response.data
        ? (Array.isArray(response.data) ? response.data : [response.data])
        : []

    const allEntities = [
        ...baseEntities,
        ...(response.included || []),
    ]

    const entityListsByType = groupBy(allEntities, 'type')
    const entityListsByTypeAndId = mapValues(entityListsByType, entityList => keyBy(entityList, 'id'))

    const resolveRelationship = relationship => {
        if (Array.isArray(relationship)) {
            return relationship.map(resolveRelationship)
        }

        return entityListsByTypeAndId[relationship.type][relationship.id]
    }

    allEntities.forEach(entity => {
        entity.relationships = mapValues(entity.relationships, relationship => resolveRelationship(relationship.data))
    })

    allEntities.forEach(entity => {
        Object.assign(entity, entity.attributes)
        Object.assign(entity, entity.relationships)
        delete entity.attributes
        delete entity.relationships
        delete entity.type
    })

    return response.data
}